const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = (theme) => ({
  textFieldL: {
    marginRight: theme.spacing.unit * 2,
    display: "block",
    minWidth: minWidth / 2,
  },
  textFieldR: {
    marginRight: theme.spacing.unit * 2,
    width: 300,
  },
  targetHeading: {
    display: "flex",
    justifyContent: "space-between",
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    "&:hover": {
      backgroundColor: "#fd5622",
    },
  },
  button: {
    backgroundColor: theme.palette.accent,
    "&:hover": {
      backgroundColor: "#fd5622",
    },
    marginLeft: 213,
    minWidth: 85,
  },
  poeSubesttexta: {
    display: "block",
    padding: 0,
    margin: 0,
  },
  poeSubesttext: {
    padding: 10,
    paddingLeft: 20,
    paddingBottom: 20,
    width: 260,
    fontFamily: "Arial, sans-serif",
  },
  checkboxLabel: {
    fontWeight: 500,
    fontSize: 15,
  },
  poeWrapper: {
    width: 500,
  },
  restoreButton: {
    padding: "0 !important",
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/subtestsetting/poeLoad/styles.js